"use client";

import { motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import Image from "next/image";
import { useModal } from "@/app/context/ModalContext";

interface LandingHeroProps {
  isDevComplete: boolean;
}

const LandingHero: React.FC<LandingHeroProps> = ({ isDevComplete }) => {
  const { isModalOpen } = useModal();
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  
  // Sample video portfolio pieces (would be dynamic in real implementation)
  const portfolioVideos = [
    "Tech Demo Reel",
    "Real Estate SF",
    "Commercial Work",
    "Documentary"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentVideoIndex((prev) => (prev + 1) % portfolioVideos.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [portfolioVideos.length]);

  return (
    <section className={`relative w-full min-h-[25vh] flex items-start justify-center overflow-hidden bg-black transition-opacity duration-500 ${isModalOpen ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-black/40 z-10" />
      
      <div className="absolute inset-0 opacity-5 z-20 pointer-events-none">
        <div className="w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0ibm9pc2UiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiIHdpZHRoPSI0IiBoZWlnaHQ9IjQiPjxyZWN0IHdpZHRoPSI0IiBoZWlnaHQ9IjQiIGZpbGw9IiMwMDAiLz48Y2lyY2xlIGN4PSIxIiBjeT0iMSIgcj0iMC41IiBmaWxsPSIjZmZmIiBvcGFjaXR5PSIwLjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjbm9pc2UpIi8+PC9zdmc+')] animate-pulse" />
      </div>

      <div className="relative z-30 w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pt-4 sm:pt-6 lg:pt-8 pb-0">
        <div className="flex justify-start">
          
          {/* Identity & Bio */}
          <motion.div 
            className="space-y-8 lg:space-y-12"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            {/* Name & Title */}
            <div className="space-y-4">
              <motion.h1 
                className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight leading-none"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
              >
                <span className="block text-white font-black">CHLOE</span>
                <span className="block text-gray-300 font-light italic">LeValley</span>
              </motion.h1>
              
              <motion.div 
                className="flex items-center space-x-4"
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
              >
                <div className="w-16 h-0.5 bg-gradient-to-r from-white to-gray-500" />
                <span className="text-gray-400 text-lg font-light tracking-wider uppercase">
                California-based Founder, Creative Producer and Director

                </span>
                
              </motion.div>
            </div>


            </motion.div>


        


        </div>


      </div>
    </section>
  );
};

export default LandingHero;